import type { IconSvgObject } from './types';

const DocumentCodeIcon: IconSvgObject = [
  ["path", { d: "M9.5 22.0015H5C3.89543 22.0015 3 21.106 3 20.0015V9.81661C3 9.28547 3.21128 8.77614 3.58724 8.40095L9.41585 2.58428C9.7908 2.21009 10.2989 1.99994 10.8286 1.99994H18C19.1046 1.99994 20 2.89537 20 3.99994V12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9.00195H8C9.10457 9.00195 10 8.10652 10 7.00195V2.00195", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 16L21 19.0026L18 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 16L12 18.9845L15 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default DocumentCodeIcon;
